// -- React Libraries
import React from 'react';
import MediaQuery from 'react-responsive';

// -- Styles
import StyleWrapper from "./Wrapper";

export default class Landing extends React.Component {
    render() {
        return (
            <StyleWrapper className="landing" onClick={this.props.onClick}>
                <div className="title">SEE HOW TO IMPOVE YOUR APP PERFORMANCE!</div>

                <MediaQuery minWidth={768}>
                    <div className="landing-content-wrapper">
                        <div className="landing-headlines">
                            <div className="headlines">App Name</div>
                            <div className="headlines">Description</div>
                            <div className="headlines">Graphics</div>
                        </div>

                        <div className="landing-contents">
                            <div className="contents">View app title diagnosis and recommendations.</div>
                            <div className="contents">View app desciption diagnosis and recommendations.</div>
                            <div className="contents">View app graphics diagnosis and recommendations.</div>
                        </div>
                    </div>
                </MediaQuery>

                <MediaQuery maxWidth={767}>
                    <div className="landing-content-wrapper">
                        <div className="landing-headlines">
                            <div className="headlines">App Name</div>
                        </div>
                        <div className="landing-contents">
                            <div className="contents">View app title diagnosis and recommendations.</div>
                        </div>
                    </div>
                    
                    <div className="landing-content-wrapper">
                        <div className="landing-headlines">
                            <div className="headlines">Description</div>
                        </div>
                        <div className="landing-contents">
                            <div className="contents">View app desciption diagnosis and recommendations.</div>
                        </div>
                    </div>
                    
                    <div className="landing-content-wrapper">
                        <div className="landing-headlines">
                            <div className="headlines">Graphics</div>
                        </div>
                        <div className="landing-contents">
                            <div className="contents">View app graphics diagnosis and recommendations.</div>
                        </div>
                    </div>
                </MediaQuery>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/Landing/index.js